"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = require("react");

var _classnames = _interopRequireDefault(require("classnames"));

var setKeys = function setKeys(obj, keys, value) {
  var key = keys.shift();

  if (!keys.length) {
    if ((0, _typeof2.default)(obj) !== 'object' || obj === null) {
      throw new Error("Couldn't set class '".concat(key, "' because ").concat(obj, " is not object."));
    }

    if (obj[key]) {
      throw new Error("Trying set ".concat(value, " to ").concat(key, ", but ").concat(key, " with value ").concat(obj[key], " already exist."));
    }

    obj[key] = value;
    return obj;
  }

  obj[key] = setKeys(obj[key] || {}, keys, value);
  return obj;
};

var mergeClasses = function mergeClasses(cssModule, classes) {
  return Object.keys(cssModule).reduce(function (res, key) {
    var value = (0, _classnames.default)(cssModule[key], classes[key]);
    var isMod = key.indexOf('--') > -1;
    var newKeys = isMod ? key.replace('--', '').split('-') : key.split('-');
    setKeys(res, newKeys, value);
    return res;
  }, {});
};

var useStyles = function useStyles(cssModule, classes) {
  var cn = (0, _react.useMemo)(function () {
    return mergeClasses(cssModule, classes);
  }, [classes, cssModule]);
  return cn;
};

exports.useStyles = useStyles;